import { ButtonLooks } from '../enums/button.js';
import { BrandfolderHexColors } from '../enums/colors.js';
import { LoaderLooks } from '../enums/loader.js';
import { brandfolderColorPalette } from './colors.js';

const defaultLightShimmerLoader = {
    gradientDark: BrandfolderHexColors.DirtyMarshmallow,
    gradientLight: BrandfolderHexColors.Marshmallow
};
const blackLoader = {
    strokeFromColor: BrandfolderHexColors.Black,
    strokeToColor: BrandfolderHexColors.GrayDark,
    textColor: BrandfolderHexColors.Black
};
const primaryDarkLoader = {
    strokeFromColor: brandfolderColorPalette.primary[400],
    strokeToColor: brandfolderColorPalette.primary[200],
    textColor: BrandfolderHexColors.White
};
const primaryLightLoader = {
    strokeFromColor: brandfolderColorPalette.primary[500],
    strokeToColor: brandfolderColorPalette.primary[300],
    textColor: BrandfolderHexColors.Black
};
const warningLoader = {
    strokeFromColor: BrandfolderHexColors.WarningRed,
    strokeToColor: '#F41D38',
    textColor: BrandfolderHexColors.Black
};
const grayLoader = {
    strokeFromColor: brandfolderColorPalette.neutrals[400],
    strokeToColor: brandfolderColorPalette.neutrals[300],
    textColor: brandfolderColorPalette.neutrals[400]
};
const whiteLoader = {
    strokeFromColor: BrandfolderHexColors.White,
    strokeToColor: BrandfolderHexColors.GrayMedium,
    textColor: BrandfolderHexColors.White
};
/**
 * Get `LoaderLooks` from `ButtonLooks`
 * @param look ButtonLooks
 * @returns LoaderLooks
 */ const getLoaderLookFromButtonLook = (look)=>{
    switch(look){
        case ButtonLooks.Default:
            {
                return LoaderLooks.Primary;
            }
        case ButtonLooks.Primary:
            {
                return LoaderLooks.Gray;
            }
        case ButtonLooks.Secondary:
            {
                return LoaderLooks.Gray;
            }
        case ButtonLooks.Tertiary:
            {
                return LoaderLooks.Gray;
            }
        case ButtonLooks.Warning:
            {
                return LoaderLooks.Gray;
            }
        default:
            {
                return LoaderLooks.White;
            }
    }
};

export { blackLoader, defaultLightShimmerLoader, getLoaderLookFromButtonLook, grayLoader, primaryDarkLoader, primaryLightLoader, warningLoader, whiteLoader };
//# sourceMappingURL=loader.js.map
